import fs from 'fs'

export function checkIfFileExists(filePath: string): boolean {
	return fs.existsSync(filePath) && fs.lstatSync(filePath).isFile()
}

export function checkIfFolderExists(folderPath: string): boolean {
	return fs.existsSync(folderPath) && fs.lstatSync(folderPath).isDirectory()
}
